console.log('modules/posts/post_single.js');
import './post_single.scss';